//帮我用 ts写一个适配器，检查是否有 Taro 的 request 或者 axio 网络请求组件，转换请求参数已适配检查到的组件并发起网络请求

import { AxiosInstance } from "axios"

interface Request {
  url: string
  method: "GET" | "POST"
  data?: RequestParams
}

interface RequestParams {
  [key: string]: string | number | boolean | undefined | RequestParams
}

let axios: AxiosInstance | undefined
let isFromDsmPool = false

export async function requestAdapter<T>(request: Request) {
  if (!axios) {
    try {
      axios = window.dsm?.pool?.axios || (await import("axios")).default
      isFromDsmPool = !!window.dsm?.pool?.axios
    } catch (e) {
      console.log(e)
    }
  }
  let data: T | undefined
  if (axios) {
    const config = {
      url: request.url,
      method: request.method,
    } as {
      url: string
      method: "GET" | "POST"
      params?: RequestParams
      data?: RequestParams
    }
    if (request.method === "GET" && request.data) {
      config.params = request.data
    } else {
      config.data = request.data
    }
    const req = await axios(config)
    if (!isFromDsmPool) {
      data = req.data
    } else {
      data = req as T
    }
  }
  return data
}

export async function getWwatherReq<T>(location: string | number, data: RequestParams) {
  // (data, location) => {
  //     return http.get(`https://odas.12301.cc/tools/weather/${location}`, {
  //         params: data
  //     })
  // }

  const res = await requestAdapter<T>({
    url: `https://odas.12301.cc/tools/weather/${location}`,
    method: "GET",
    data,
  })
  // console.log(res)
  return res
}
